// Action fired on view change
export const CHANGE_VIEW = "CHANGE_VIEW";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REQUEST_START = "REQUEST_START";
export const REQUEST_END = "REQUEST_END";
export const CALLS_UPDATE = "CALLS_UPDATE";
export const RECONCILIATION_CONTROL = "RECONCILIATION_CONTROL";
